import { buildStyle } from "@eusoft/webapp-core/utils/Style";
import { Class } from "@eusoft/webapp-jsx/components/Class";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { NodeView } from "@eusoft/webapp-ui/components/NodeView";
import type { ComponentStyle } from "@eusoft/webapp-core/abstraction/IComponentOptions";
import type { ViewNode } from "@eusoft/webapp-ui/types";
import "./Card.scss"

interface ICardOptions {
    content: ViewNode;
    style?: ComponentStyle;
    header?: ViewNode;
    name?: string;
    collapsable?: boolean;
}

export function Card(options: ICardOptions) {

    const state = {
        isCollapsed: false as boolean
    };

    const toggle = () => {
        state.isCollapsed = !state.isCollapsed;
    };

    return <section className={buildStyle("card", options.style, options.name)}>
        <Class name="collapsable" condition={options.collapsable} />
        <Class name="collapsed" condition={state.isCollapsed} />
        <Class name="expanded" condition={!state.isCollapsed} />
        {options.header && <header on-click={() => toggle()}>
            <div><NodeView>{options.header}</NodeView></div>
            {options.collapsable && <MaterialIcon name="keyboard_arrow_down" />}
        </header>}
        <div className="body">
            {options.content}
        </div>
    </section>
}